const MAX_UNICODE_CODE_POINT = 0x10ffff;
const SURROGATE_CODE_POINT_MIN = 0xd800;
const SURROGATE_CODE_POINT_MAX = 0xdfff;
const HEX_CODE_POINT_PATTERN = /^[0-9a-f]+$/i;
function parseUnifiedCodePoint(hex) {
    if (!HEX_CODE_POINT_PATTERN.test(hex))
        return null;
    const codePoint = Number.parseInt(hex, 16);
    if (!Number.isInteger(codePoint))
        return null;
    if (codePoint < 0 || codePoint > MAX_UNICODE_CODE_POINT)
        return null;
    if (codePoint >= SURROGATE_CODE_POINT_MIN && codePoint <= SURROGATE_CODE_POINT_MAX)
        return null;
    return codePoint;
}
export function unifiedEmojiToString(unified) {
    const codePoints = [];
    for (const hex of unified.split('-')) {
        const codePoint = parseUnifiedCodePoint(hex);
        if (codePoint == null)
            return null;
        codePoints.push(codePoint);
    }
    return String.fromCodePoint(...codePoints);
}
//# sourceMappingURL=unifiedEmojiToString.js.map